import React from 'react';
import { ActivityIcon, BrainIcon, BedIcon, AlertCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-[#0f1419] py-16 md:py-24 px-4" data-id="element-187">
      <div className="max-w-6xl mx-auto" data-id="element-188">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-12 text-center" data-id="element-189">
          Presentándote el Protocolo 3C
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-190">
          {/* C1 - Cuerpo */}
          <div className="bg-[#1e2738] rounded-2xl p-8 shadow-lg shadow-black/20 ring-1 ring-white/5" data-id="element-191">
            <div className="w-16 h-16 bg-[#e76f51] rounded-full flex items-center justify-center mb-6 shadow-lg shadow-[#e76f51]/20" data-id="element-192">
              <ActivityIcon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-193" />
            </div>
            <h3 className="text-2xl font-bold text-[#e8edf4] mb-4" data-id="element-194">
              C1 — CUERPO
            </h3>
            <p className="text-lg text-[#d1d9e6]" data-id="element-195">
              bajar activación en 2–6 minutos
            </p>
          </div>

          {/* C2 - Cerebro */}
          <div className="bg-[#1e2738] rounded-2xl p-8 shadow-lg shadow-black/20 ring-1 ring-white/5" data-id="element-196">
            <div className="w-16 h-16 bg-[#8b9dc3] rounded-full flex items-center justify-center mb-6 shadow-lg shadow-[#8b9dc3]/20" data-id="element-197">
              <BrainIcon className="w-8 h-8 text-white" aria-hidden="true" data-id="element-198" />
            </div>
            <h3 className="text-2xl font-bold text-[#e8edf4] mb-4" data-id="element-199">
              C2 — CEREBRO
            </h3>
            <p className="text-lg text-[#d1d9e6]" data-id="element-200">
              sacar la mente de la cama con un brain dump dirigido
            </p>
          </div>

          {/* C3 - Cama */}
          <div className="bg-[#1e2738] rounded-2xl p-8 shadow-lg shadow-black/20 ring-1 ring-white/5" data-id="element-201">
            <div className="w-16 h-16 bg-[#2a3447] rounded-full flex items-center justify-center mb-6 ring-1 ring-[#a8b5d1]/30" data-id="element-202">
              <BedIcon className="w-8 h-8 text-[#a8b5d1]" aria-hidden="true" data-id="element-203" />
            </div>
            <h3 className="text-2xl font-bold text-[#e8edf4] mb-4" data-id="element-204">
              C3 — CAMA
            </h3>
            <p className="text-lg text-[#d1d9e6]" data-id="element-205">
              aterrizaje con anclas sensoriales
            </p>
          </div>
        </div>

        {/* 3AM Emergency Plan */}
        <div className="bg-gradient-to-br from-[#1a1f2e] to-[#0f1419] rounded-2xl p-8 md:p-12 text-white shadow-xl shadow-black/30 ring-1 ring-[#a8b5d1]/10" data-id="element-206">
          <div className="flex items-start gap-4 mb-6" data-id="element-207">
            <AlertCircleIcon className="w-12 h-12 text-[#a8b5d1] flex-shrink-0" aria-hidden="true" data-id="element-208" />
            <div data-id="element-209">
              <h3 className="text-2xl md:text-3xl font-bold mb-4 text-[#e8edf4]" data-id="element-210">
                El Plan de Emergencia 3AM
              </h3>
              <p className="text-lg md:text-xl leading-relaxed text-[#d1d9e6]" data-id="element-211">
                Ese momento en que te despiertas y sientes: "ya perdí la noche".
              </p>
            </div>
          </div>
          <p className="text-lg md:text-xl leading-relaxed text-[#d1d9e6]" data-id="element-212">
            Aquí no improvisas. Tienes 6 pasos simples para volver a bajarte sin
            mirar el reloj, sin pelear y sin negociar con pensamientos.
          </p>
        </div>
      </div>
    </section>;
}